import LANG from '../../../lang/prop-en-module.js';

export function alertMessagePopup(text) {
  const opt = {
    title: 'Info',
    body: text,
  };
  $('#messagePopUpTitle').html(opt.title ? opt.title : '');
  $('#messagePopUpBody').html(opt.body ? opt.body : '');
  $('#messagePopUp').modal('show');
}

export function confirmPopup(params) {
  const { title = '', body = '', customFooterHtml, callback } = params;
  $('#confirmPopUpTitle').html(title);
  $('#confirmPopUpBody').html(body);
  if (customFooterHtml) {
    $('#confirmPopUpFooter').html(customFooterHtml);
  } else {
    $('#confirmPopUpFooter').html(`
      <button type="button" class="btn btn-sm" data-dismiss="modal">Cancel</button>
      <button type="button" id="confirmCallback" class="btn btn-sm btn-danger" data-dismiss="modal">Delete</button>
    `);
  }
  const $confirmButton = $('#confirmCallback');
  $confirmButton.off('click');
  $confirmButton.one('click', callback);
  $('#confirmPopUp').modal('show');
}

export function attendeeIdCopiedPopup() {
  const text = LANG.attendee_id_copied;
  alertMessagePopup(text);
}
